import React, { useEffect, useState } from "react"
import styled from "styled-components"
import { StoryItem, StoryItemProps } from "./StoryItem"

import {
  Space,
  Scroller,
  Room,
  RoomSide,
  Wallpaper,
  RoomSideEnum,
  useRoomMovement,
  RoomHoverText,
} from "../RoomExperience"

import Video from "../Video/Video"
import CloseIcon from "../../images/Close.svg"
import { GlitchEffect } from "../GlitchEffect/Glitch"
import CloseButton from "../Header/components/CloseButton"


interface VideoRoomProps {
  data? : any,
  transitionStatus? : any,
  enableTilt? : boolean,
  showInfo? : boolean,
  onInfo? : () => void,
  children? : any,
  floorColor? : string,
  topColor? : string,
  leftColor? : string,
  rightColor?: string
  tileSize? : string
  firstImageLayout? : StoryItemProps,
  secondImageLayout? : StoryItemProps,
	greetingsImageSRC?:string
}

interface VideoImage {
  birting? : string,
  backgroundImage : any,
  visible: boolean
}

const VideoRooms = ({
  data,
  transitionStatus,
  enableTilt,
  showInfo,
  onInfo,
  children,
  floorColor,
  topColor,
  rightColor,
  leftColor,
  backColor,
  tileSize,
  firstImageLayout,
  secondImageLayout,
  greetingsImageSRC
}: VideoRoomProps) => {

  const { scrollerRef } = useRoomMovement({
    enableTilt,
    enableTopView: showInfo,
    transitionStatus,
  })

  const [ActiveItem, setActiveItem] = useState<StoryItemProps>({})

  const [images, setImages] = useState<Array<VideoImage>>(data.allStory.edges.map((edge)=>{
    return {
      backgroundImage : edge.node.backgroundImage,
      birting : edge.node.birting,
      visible : false
      }
  }))


  const closeVideo = () => {
    onInfo(false)
  }

  const handleClick = (item: StoryItemProps) => {
    const birting = parseFloat(item.birting);
    const now = Math.round((new Date()).getTime() / 1000);
    if(now >= birting){
      onInfo(true)
      setActiveItem(item)
    }
  }

  const checkImages = () =>{
    const updatedImages : Array<VideoImage> = images.map((item)=>{
      const birting = parseFloat(item.birting);
      const now = Math.round((new Date()).getTime() / 1000);
      const isVisible = (now >= birting)
        return {
          backgroundImage: item.backgroundImage,
          birting : item.birting,
          visible : isVisible
        }
    })
    setImages(updatedImages);
  }
  

  useEffect(()=>{
    checkImages()
    const inter = setInterval(()=>{
        checkImages()
    }, 3000)
    return ()=>{
      clearInterval(inter)
    }
  },[])
  


  const handleHover = (item: StoryItemProps) => {
    const birting = parseFloat(item.birting);
    const now = Math.round((new Date()).getTime() / 1000);
    if((now) >= birting){
      setActiveItem(item)
    }
  }

  return (
    <>
      <Space>
        <Scroller ref={scrollerRef}>
          <Room>
            <RoomSide
              className={RoomSideEnum.Right}
              style={{ overflow: "hidden" }}
            >
              {rightColor != undefined ? (
                <SolidWall color={rightColor}></SolidWall>
              ) : (
              <Wallpaper
                fluid={data.concreteWall.childImageSharp.fluid}
                backgroundColor="#585858"
                tileSize={tileSize}
              />
              )}
              {data.allStory != null && data.allStory.edges[4] != null && 
              <StoryItem
                xPos="35%"
                heightPercentage="60%"
                widthPercentage="20%"
                handleHover={() => handleHover(data.allStory.edges[4].node)}
                handleClick={() => handleClick(data.allStory.edges[4].node)}
              >
                {data.allStory.edges[4].node.backgroundImage != null && (
                  <GlitchContainer>
                    <GlitchEffect
                      backgroundImage={
                        images[4].visible ? images[4].backgroundImage.childImageSharp.fluid : data.afsakidhle.childImageSharp.fluid
                      }
                      small={true}
                    ></GlitchEffect>
                  </GlitchContainer>
                )}
              </StoryItem>
              }
              {data.allStory != null && data.allStory.edges[3] != null && 
              <StoryItem
                xPos="10%"
                heightPercentage="60%"
                widthPercentage="20%"
                handleHover={() => handleHover(data.allStory.edges[3].node)}
                handleClick={() => handleClick(data.allStory.edges[3].node)}
              >
                {data.allStory.edges[4].node.backgroundImage != null && (
                  <GlitchContainer>
                    <GlitchEffect
                      backgroundImage={
                        images[3].visible ? images[3].backgroundImage.childImageSharp.fluid : data.afsakidhle.childImageSharp.fluid
                      }
                      small={true}
                    ></GlitchEffect>
                  </GlitchContainer>
                )}
              </StoryItem>
              }{data.allStory != null && data.allStory.edges[5] != null && 
                <StoryItem
                  xPos="60%"
                  heightPercentage="60%"
                  widthPercentage="20%"
                  handleHover={() => handleHover(data.allStory.edges[5].node)}
                  handleClick={() => handleClick(data.allStory.edges[5].node)}
                >
                  {data.allStory.edges[5].node.backgroundImage != null && (
                    <GlitchContainer>
                      <GlitchEffect
                        backgroundImage={
                          images[5].visible ? images[5].backgroundImage.childImageSharp.fluid : data.afsakidhle.childImageSharp.fluid
                        }
                        small={true}
                      ></GlitchEffect>
                    </GlitchContainer>
                  )}
                </StoryItem>
                }
            </RoomSide>

            <RoomSide className={RoomSideEnum.Left}>
              {leftColor != undefined ? (
                <SolidWall color={leftColor}></SolidWall>
              ) : (
                <Wallpaper
                  fluid={data.concreteWall.childImageSharp.fluid}
                  backgroundColor="#585858"
                  tileSize={tileSize}
                />
              )}
              
            </RoomSide>
            <RoomSide className={RoomSideEnum.Bottom}>
              {floorColor != undefined ? (
                <SolidWall color={floorColor}></SolidWall>
              ) : (
                <Wallpaper
                  fluid={data.concreteWall.childImageSharp.fluid}
                  backgroundColor="#585858"
                  tileSize={tileSize}
                />
              )}
            </RoomSide>
            <RoomSide className={RoomSideEnum.Top}>
              {topColor != undefined ? (
                <SolidWall color={topColor}></SolidWall>
              ) : (
                <Wallpaper
                  fluid={data.concreteWall.childImageSharp.fluid}
                  backgroundColor="#585858"
                  tileSize={tileSize}
                />
              )}
              
            </RoomSide>
            <RoomSide className={RoomSideEnum.Back}>
              {/* TODO Backcolor? */}
              {backColor != undefined ? (
                <SolidWall color={backColor}></SolidWall>
              ) : (
                <Wallpaper
                  fluid={data.concreteWall.childImageSharp.fluid}
                  backgroundColor="#585858"
                  tileSize={tileSize}
                />
              )}
              {data.allStory != null && data.allStory.edges[2] != null && 
              <StoryItem
                xPos="67%"
                heightPercentage="60%"
                widthPercentage="30%"
                handleHover={() => handleHover(data.allStory.edges[2].node)}
                handleClick={() => handleClick(data.allStory.edges[2].node)}
              >
                {data.allStory.edges[2].node.backgroundImage != null && (
                  <GlitchContainer>
                    <GlitchEffect
                      backgroundImage={
                        images[2].visible ? images[2].backgroundImage.childImageSharp.fluid : data.afsakidhle.childImageSharp.fluid
                      }
                      small={true}
                    ></GlitchEffect>
                  </GlitchContainer>
                )}
              </StoryItem>
              }
              {data.allStory != null && data.allStory.edges[0] != null && 
              <StoryItem
                xPos="3%"
                heightPercentage="60%"
                widthPercentage="30%"
                handleHover={() => handleHover(data.allStory.edges[0].node)}
                handleClick={() => handleClick(data.allStory.edges[0].node)}
              >
                {data.allStory.edges[0].node.backgroundImage != null && (
                  <GlitchContainer>
                    <GlitchEffect
                      backgroundImage={
                        images[0].visible ? images[0].backgroundImage.childImageSharp.fluid : data.afsakidhle.childImageSharp.fluid
                      }
                      small={true}
                    ></GlitchEffect>
                  </GlitchContainer>
                )}
              </StoryItem>
                }
                {data.allStory != null && data.allStory.edges[1] != null && 
               <StoryItem
                xPos="35%"
                heightPercentage="60%"
                widthPercentage="30%"
                handleHover={() => handleHover(data.allStory.edges[1].node)}
                handleClick={() => handleClick(data.allStory.edges[1].node)}
              >
                {data.allStory.edges[1].node.backgroundImage != null && (
                  <GlitchContainer>
                    <GlitchEffect
                      backgroundImage={
                        images[1].visible ? images[1].backgroundImage.childImageSharp.fluid : data.afsakidhle.childImageSharp.fluid
                      }
                      small={true}
                    ></GlitchEffect>
                  </GlitchContainer>
                )}
              </StoryItem>
              }
            </RoomSide>
            
					  <DoorManImg src={greetingsImageSRC} />
          </Room>

          <RoomHoverText
            title={ActiveItem.speakerName}
            description={ActiveItem.companyName}
          />
          
        </Scroller>
      </Space>

      {/* TODO */}
      {/* <Content ref={contentRef} className={ContentActive == true ? "active" : ""}> */}
      <Content className={showInfo ? "active" : ""}>
        <VideoCloseButton onClick={closeVideo}>X</VideoCloseButton>
        <Video
          videoSrcURL={ActiveItem.videolink}
          height="50vh"
          width="50vw"
          centerScreen={true}
        />
      </Content>
    </>
  )
}
const DoorManImg = styled.img`
	pointer-events: none;
	transform-origin: 50% 50%;
	justify-content: flex-start;
	transform: translate3d(-40px,35px,-750px) rotate3d(0,1,0,0deg);
	width: 500px;
	height: auto;
	position: absolute;
	left: 0;
	bottom: 0;
	backface-visibility: hidden;
	height: 80vh;
	/* pointer-events: none; */
`
const VideoCloseButton = styled(CloseButton)`
position:absolute;
top:30px;
right: 165px;
`

const ActualImg = styled.img`
  height: 100%;
  width: 100%;
  object-fit:cover;
`

const WallpaperFloor = styled(Wallpaper)`
background-size: contain;
background-repeat: repeat;
`

const WallpaperTop = styled(Wallpaper)`
background-size: contain;
background-repeat: repeat;
`

interface SolidFloorProps{
  color: string
}
const SolidWall = styled.div<SolidFloorProps>`
  background: ${({color}) => color};
  height:100%;
  width:100%;
`

const CloseVideoButton = styled.button`
  position: absolute;
  top: 30px;
  right: 20px;
  height: 50px;
  width: 50px;
  background-color: white;
  border-radius: 50%;
  border: none;
  z-index: 202;

  &:after {
    content: "";
    position: absolute;
    left: 15px;
    top: 14px;
    height: 20px;
    width: 20px;
    background-image: url(${CloseIcon});
    background-size: contain;
    background-repeat: no-repeat;
    background-position: 50%;
  }
`

const Content = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  padding: 2vw;
  background: rgba(152, 19, 156, 0.5);
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.6s ease;
  z-index: 202;

  &.active {
    opacity: 1;
    pointer-events: auto;
  }

  h1 {
    color: white;
  }
`
const GlitchContainer = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
`

export default VideoRooms
